import { useEffect, useRef, useState} from "react";
import { Button, Modal } from "react-bootstrap";
import PrintAction from "../../button-in-phieu/components/PrintAction";
import { EXPORT_TYPE } from "../../button-in-phieu/constant";
import FilePreview from "./FilePreview";

type FormInPhieuProps<T> = {
    show: boolean;
    title?: string;
    fileName?: string;
    base64?: string;
    onHide: () => void;
    shouldNotShowLabelExport?: boolean;
    shouldNotShowExportPDF?: boolean;
    shouldNotShowExportDOC?: boolean;
};

// function base64ToBlob(base64: string) {
//     let contentType = "application/octet-stream";
//     const mimeMatch = base64.match(/^data:(.*?);base64,/);
//     if (mimeMatch) {
//         contentType = mimeMatch[1];
//     }

//     let cleaned = base64.replace(/^data:.*;base64,/, "");

//     cleaned = cleaned.replace(/-/g, "+").replace(/_/g, "/");

//     cleaned = cleaned.replace(/[^A-Za-z0-9+/=]/g, "");

//     const byteCharacters = atob(cleaned);
//     const byteNumbers = new Array(byteCharacters.length);
//     for (let i = 0; i < byteCharacters.length; i++) {
//         byteNumbers[i] = byteCharacters.charCodeAt(i);
//     }

//     const byteArray = new Uint8Array(byteNumbers);
//     const blob = new Blob([byteArray], { type: contentType });

//     return URL.createObjectURL(blob);
// }

function base64ToBlob(base64: string, defaultMime = "application/pdf") {
    // Nếu base64 có prefix kiểu "data:xxx;base64,"
    let mime = defaultMime;
    const matches = base64.match(/^data:(.*?);base64,/);

    let cleanedBase64 = base64;

    if (matches) {
        mime = matches[1];
        cleanedBase64 = base64.replace(/^data:.*;base64,/, "");
    }

    // KHÔNG xoá ký tự + / = (rất quan trọng)
    cleanedBase64 = cleanedBase64.trim();

    const byteCharacters = atob(cleanedBase64);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += 512) {
        const slice = byteCharacters.slice(offset, offset + 512);
        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }
        byteArrays.push(new Uint8Array(byteNumbers));
    }

    const blob = new Blob(byteArrays, { type: mime });
    return URL.createObjectURL(blob);
}



function base64ToWordBlob(base64: string) {
    const contentType = "application/vnd.openxmlformats-officedocument.wordprocessingml.document";

    let cleaned = base64.replace(/^data:.*;base64,/, "");
    cleaned = cleaned.replace(/-/g, "+").replace(/_/g, "/");
    cleaned = cleaned.replace(/[^A-Za-z0-9+/=]/g, "");

    const byteCharacters = atob(cleaned);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: contentType });

    return URL.createObjectURL(blob);
}

const FormInPhieuDialog = <T extends object>({ show, onHide, title = 'In Phiếu', fileName = '', base64 = '', shouldNotShowLabelExport, shouldNotShowExportPDF, shouldNotShowExportDOC }: FormInPhieuProps<T>) => {
    const iframeRef = useRef<HTMLIFrameElement>(null);
    const [srcPreview, setSrcPreview] = useState<string>('');

    useEffect(() => {
        if (!base64) return;
        const url = base64ToBlob(base64);
        setSrcPreview(url);
    }, [base64]);

    const onPrint = () => {
        if (iframeRef.current) {
            iframeRef.current.focus();
            iframeRef.current.contentWindow?.print();
        }
    };

    const onExport = (type: any) => {
        if (!base64) return;

        let url = "";
        let name = fileName || "file";

        switch (type) {
            case EXPORT_TYPE.PDF:
                url = base64ToBlob(base64);               // pdf
                name += ".pdf";
                break;

            case EXPORT_TYPE.DOC:
                url = base64ToWordBlob(base64);          // docx
                name += ".docx";
                break;

            default:
                console.warn("Loại export không hợp lệ:", type);
                return;
        }

        const a = document.createElement("a");
        a.href = url;
        a.download = name;
        a.click();
        URL.revokeObjectURL(url);
    };


    return (
        <Modal centered show={show} onHide={onHide} fullscreen>
            <Modal.Header closeButton className="py-5 bg-white">
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>

            <Modal.Body className="p-8">
                <div className="d-flex flex-row h-100">
                    <div className="flex-grow-1">
                        {!srcPreview ? (
                            <div className="d-flex justify-content-center align-items-center h-100">
                                <em className="fs-3 text-gray-600">Không có dữ liệu.</em>
                            </div>
                        ) : (
                            <FilePreview src={srcPreview} ref={iframeRef} />
                        )}
                    </div>
                    <div className="w-150 ms-3 ps-5 border-start">
                        <PrintAction
                            onPrint={onPrint}
                            onExport={onExport}
                        />
                    </div>
                </div>
            </Modal.Body>

            <Modal.Footer>
                <Button className="btn btn-danger" onClick={onHide}>
                    Đóng
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default FormInPhieuDialog;